<template>
  <div
    id="footer"
    class="fixed bottom-0 bg-gray-100 w-full border-t border-solid border-gray-200 opacity-100 py-2"
    style="left:0"
  >
    <div class="md:ml-64 flex flex-row px-4 justify-between items-center">
      <div class="block w-32">
        <!-- Color Picker start -->
        <BasePopover :showPopover="colorSettings" placement="right">
          <template v-slot:button>
            <button
              class="menu flex flex-col items-center justify-center relative border border-solid border-gray-400 p-2 bg-gray-600"
              v-tooltip="'Background Color'"
              @click="colorSettings = true"
              :style="{
                'box-shadow': 'none',
              }"
            >
              <span class="material-icons" :style="{ color: showColor }">
                palette
              </span>
            </button>
          </template>

          <template v-slot:body>
            <div
              id="button-settings"
              class=" bg-gray-800 rounded mt-2 z-10 inline-block text-left pl-3 pb-3 pt-1"
              style="right: 0%;"
            >
              <div class="flex flex-row-reverse justify-between">
                <div @click="colorSettings = false">
                  <svg-icon
                    icon="heroicons/outline/x"
                    class="w-3 h-3 text-gray-400 hover:text-gray-300 font-bold my-auto mr-2 cursor-pointer"
                  />
                </div>

                <div class="flex flex-row mb-1">
                  <input
                    type="checkbox"
                    id="checkbox"
                    v-model="checked"
                    class="my-auto"
                  />
                  <label for="checkbox" class="text-xs text-white my-auto"
                    >Use theme default</label
                  >
                </div>
              </div>

              <div class="pr-3">
                <verte
                  model="hex"
                  v-model="showColor"
                  display="widget"
                  :enableAlpha="false"
                  :showHistory="false"
                >
                  <div
                    class="h-5 w-5 border border-solid border-white ml-2"
                    :style="{ background: showColor }"
                  ></div>
                </verte>
              </div>
            </div>
          </template>
        </BasePopover>
      </div>

      <!-- Step pager -->

      <nav class="block flex items-center">
        <draggable
          v-model="steps"
          class="flex flex-wrap my-auto"
          :disabled="!reorderSteps"
        >
          <div v-for="(step, index) of steps" :key="index">
            <div
              v-tooltip="{
                content: !reorderSteps
                  ? 'Go to step ' + parseInt(index + 1)
                  : '',
                classes: ['tall'],
              }"
              class="flex h-8 w-8 cursor-pointer first:ml-0 text-sm font-semibold mx-1 pt-0 rounded-full items-center justify-center leading-tight relative border border-solid border-purple-500 "
              :class="pagerClass(index)"
              @click="$emit('select-step', index)"
            >
              {{ index + 1 }}
            </div>
          </div>
        </draggable>

        <div v-if="!reorderSteps" @click="reorderSteps = !reorderSteps">
          <svg-icon
            icon="heroicons/solid/refresh"
            class=" text-xs font-semibold flex w-10 h-10 p-0 rounded-full items-center justify-center leading-tight relative text-gray-300 hover:text-purple-700 cursor-pointer"
            v-tooltip="!reorderSteps ? 'Re-order steps ' : 'Done re-ordering'"
          />
        </div>

        <div v-else class="flex flex-row items-center justify-center">
          <div class="text-sm my-auto text-gray-500">
            Drag step to re-order
          </div>
          <button
            @click="reorderSteps = !reorderSteps"
            class="block bg-gray-600 hover:bg-gray-700 text-white font-bold uppercase text-xs px-4 py-1 mr-5 rounded outline-none focus:outline-none m-1"
            type="button"
          >
            Done Re-ordering
          </button>
        </div>
      </nav>

      <!--End Pagination -->

      <nav class="block">
        <ul class="flex pl-0 rounded list-none flex-wrap">

          <li>
            <BaseDropDown
              v-on:add-step="remit"
              v-bind:items="[
                {
                  event: 'add-step',
                  label: 'Welcome Page',
                  args: 'welcome',
                  icon: 'heroicons/outline/emoji-happy',
                },
                {
                  event: 'add-step',
                  args: 'image',
                  label: 'Survey Question (image)',
                  icon: 'heroicons/outline/photograph',
                },
                {
                  event: 'add-step',
                  args: 'text',
                  label: 'Survey Question (text)',
                  icon: 'heroicons/outline/document-text',
                },
                {
                  event: 'add-step',
                  args: 'flex',
                  label: 'Blank Page',
                  icon: 'heroicons/outline/photograph',
                },
                {
                  event: 'add-step',
                  args: 'modal',
                  label: 'Modal',
                  icon: 'heroicons/outline/annotation',
                },
              ]"
            >
              <template v-slot:button>
                <svg-icon
                  icon="heroicons/outline/plus-circle"
                  class="text-sm font-semibold flex w-10 h-10 p-0 rounded-full items-center justify-center leading-tight relative text-gray-300 hover:text-purple-700 cursor-pointer"
                  v-tooltip="'Add a new step'"
                />
              </template>

              <template v-slot:header>
                <div class="text-sm font-semibold py-2 px-4 mx-auto">
                  ADD A STEP
                </div>
                <div class="border border-solid border-gray-200"></div>
              </template>
            </BaseDropDown>
          </li>

            <li
            v-tooltip="'Clone current step'" @click="$emit('clone-step')"
            class="text-gray-300 hover:text-purple-700 cursor-pointer"
          >
            <svg-icon
              icon="heroicons/outline/duplicate"
              class="text-sm font-semibold flex w-10 h-10 p-0 rounded-full items-center justify-center leading-tight relative"
            />
          </li>

          <li
            v-tooltip="'Delete current step'"
            @click="$emit('confirm-delete')"
            class="text-gray-300 hover:text-purple-700 cursor-pointer"
          >
            <svg-icon
              icon="heroicons/outline/x-circle"
              class="text-sm font-semibold flex w-10 h-10 p-0 rounded-full items-center justify-center leading-tight relative"
            />
          </li>



        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
import Draggable from "vuedraggable";
import Step from "@/models/Step";
import Survey from "@/models/Survey";
//Verte Color Picker
//https://baianat.github.io/verte/guide/
import Verte from "verte";
export default {
  components: { Draggable, Verte },
  props: ["survey", "step", "currentStep", "saving"],
  data() {
    return {
      reorderSteps: false,
      colorSettings: false,
      checked: false,
    };
  },
  computed: {
    steps: {
      get() {
        return this.survey.steps;
      },
      set(steps) {
        var reorderedList = Step.reIndexList(steps);
        Step.update({
          data: reorderedList,
        });
      },
    },

    //custom background color for the step
    bgColor: {
      get() {
        return this.step.bgColor;
      },
      set(value) {
        Step.update({ where: this.step.id, data: { bgColor: value } });
      },
    },

    showColor: {
      get() {
        //show custom background color for the step, or else survey default
        return this.step.bgColor ?? this.survey.bgColor;
      },
      set(value) {
        if (!this.checked) {
          Step.update({ where: this.step.id, data: { bgColor: value } });
        }
      },
    },
    allowMany: {
      get() {
        return this.step.allow_many;
      },
      set(value) {
        //console.log("allowmany value: " + value);
        if (value !== this.step.allow_many) {
          Step.update({ where: this.step.id, data: { allow_many: value } });
        }
      },
    },
  },
  methods: {
    pagerClass(index) {
      if (index == this.currentStep)
        return "text-white bg-purple-600 border border-transparenet";
      else if (this.reorderSteps)
        return "text-purple-600 bg-white border border-dashed border-purple-400 cursor-move";
      else
        return "text-purple-600 bg-white hover:bg-purple-100 border border-transparent";
    },
    remit(template) {
      this.$emit("add-step", template);
    },
  },

  /* Not sure why i can't get this to work as a computed property, but this works ok */
  watch: {
    checked() {
      if (this.checked == true) this.bgColor = null;
    },
    bgColor() {
      if (this.bgColor == null) this.checked = true;
      else this.checked = false;
    },
  },

  mounted() {
    if (this.bgColor == null) this.checked = true;
    else this.checked = false;
  },
};
</script>

<style></style>
